import {bgmi} from './bgmi/bgmi';
import {Brand} from './Brand';
import {BrandId} from './BrandId';
import {chatCoffee} from './chatCoffee/chatCoffee';
import {chatiwi} from './chatiwi/chatiwi';
import {chatiwin} from './chatiwin/chatiwin';
import {hard} from './hard/hard';
import {sextingAnonymous} from './sextingAnonymous/sextingAnonymous';
import {sextyNine} from './sextyNine/sextyNine';

export const brands: Record<BrandId, Brand> = {
  bgmi,
  chatiwin,
  chatiwi,
  chatCoffee,
  hard,
  sextyNine,
  sextingAnonymous,
};
